import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { setCurrentStudio } from '~entities/studios/model/studio-store';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { StudioDetails } from '../model/types';

export const getStudioDetailsAPI = async () => {
  const response = await baseAPI.get<StudioDetails>(`/studios/location`);
  const studioDetails = response.data;
  setCurrentStudio(studioDetails);
  return response.data;
};

export const useGetStudioDetails = (
  options?: Omit<UseQueryOptions<StudioDetails>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    queryKey: [KEYS.STUDIO_DETAILS],
    queryFn: () => getStudioDetailsAPI(),
    ...options,
  });
};
